import { fetchArticle } from '../services/article.service'
import { extractArticle } from './transformers/article.transformer'

export const ArticleModule = {
  namespaced: true,
  state: {
    loading: true,
    exception: false,
    article: null
  },
  mutations: {
    setLoading: (state, loading) => state.loading = loading,
    setException: (state, exception) => state.exception = exception,
    setArticle: (state, article) => state.article = article
  },
  actions: {
    async loadArticle ({ commit }, path) {
      try {
        const parts = path.split('/')
        const id = parts[parts.length - 1]

        const response = await fetchArticle(id)
        const extractedArticle = extractArticle(response)

        commit('setArticle', extractedArticle)
      } catch (err) {
        commit('setException', true)
      } finally {
        commit('setLoading', false)
      }
    }
  }
}
